import React from "react";
import "./UCheckbox.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";

interface IProps {
    value: boolean;
}

export default function USimpleCheckbox({ value }: IProps) {
    if (value)
        return (
            <div className="uCheckbox-checked">
                <FontAwesomeIcon icon={faCheck} />
            </div>
        );
    return <div className="uCheckbox"></div>;
}
